import { Stack } from '@mui/material'
import TrimPage from 'components/cattles/trim/TrimPage'

const LamenessTrim = () => {
	return (
		<Stack direction='column' gap='16px'>
			<TrimPage />
		</Stack>
	)
}

export default LamenessTrim
